export default __webpack_public_path__ + "static/media/charge_point_outline.507dd482.svg";